import { call, put, takeEvery } from "redux-saga/effects"

// Crypto Redux States
import { GET_SERTS, GET_SERT_PROFILE, ADD_NEW_SERT, DELETE_SERT, UPDATE_SERT, GET_CLASS } from "./actionTypes"

import {
  getSertsSuccess,
  getSertsFail,
  addSertFail,
  addSertSuccess,
  updateSertSuccess,
  updateSertFail,
  deleteSertSuccess,
  deleteSertFail,
  getClassesFail,
  getClassesSuccess,
} from "./actions"

//Include Both Helper File with needed methods
import { getSerts, addNewSert, updateSert, deleteSert, getClass } from "../../helpers/fakebackend_helper"

// toast
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

function* fetchSerts({ payload: id}) {
  try {
    const response = yield call(getSerts, id)
    yield put(getSertsSuccess(response))
  } catch (error) {
    yield put(getSertsFail(error))
  }
}

function* fetchClass({ payload: id}) {
  try {
    const response = yield call(getClass, id)
    yield put(getClassesSuccess(response))
  } catch (error) {
    yield put(getClassesFail(error))
  }
}


function* onUpdateSert({ payload: user }) {
  try {
    const response = yield call(updateSert, user)
    yield put(updateSertSuccess(response))
    toast.success("Contact Updated Successfully", { autoClose: 2000 });
  } catch (error) {
    yield put(updateSertFail(error))
    toast.error("Contact Updated Failed", { autoClose: 2000 });
  }
}

function* onDeleteSert({ payload: user }) {
  try {
    const response = yield call(deleteSert, user)
    yield put(deleteSertSuccess(response))
    toast.success("Contact Deleted Successfully", { autoClose: 2000 });
  } catch (error) {
    yield put(deleteSertFail(error))
    toast.error("Contact Deleted Failed", { autoClose: 2000 });
  }
}

function* onAddNewSert({ payload: user }) {

  try {
    const response = yield call(addNewSert, user)
    console.log('user', user);
    console.log('response', response);
    
    if(response?.success) {
      console.log('response2', response);
      
      // yield put(addSertSuccess(user))
      toast.success("Added Successfully", { autoClose: 2000 });
      if(user?.parent_id){
        fetchSerts({ payload: user?.parent_id})
      }else{
        fetchSerts({ payload: null})
      }
    }else {
      toast.error(response?.message ?? "Added Failed", { autoClose: 2000 });
    }

    document.getElementById('cloasemodelwhen')?.click()
  } catch (error) {
    yield put(addSertFail(error))
    toast.error("Added Failed", { autoClose: 2000 });
  }
}

function* sertsSaga() {
  yield takeEvery(GET_SERTS, fetchSerts)
  yield takeEvery(GET_CLASS, fetchClass)
  // yield takeEvery(GET_SERT_PROFILE, fetchSertProfile)
  yield takeEvery(ADD_NEW_SERT, onAddNewSert)
  yield takeEvery(UPDATE_SERT, onUpdateSert)
  yield takeEvery(DELETE_SERT, onDeleteSert)
}

export default sertsSaga;
